import { Handle, Position } from "@xyflow/react";
import { motion } from "framer-motion";
import { FC } from "react";
import { Box, Typography } from "@mui/material";
import __ from "src/utils/Translations";

interface IBottomHandle {
  handleClick: () => void;
  isClickedNodeCollapsed: boolean;
}

const BottomHandle: FC<IBottomHandle> = ({
  handleClick,
  isClickedNodeCollapsed,
}) => {
  const rotate = isClickedNodeCollapsed ? { rotate: "180deg" } : null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.2, delay: 0.4 } }}
    >
      <Handle
        type="source"
        position={Position.Bottom}
        onClick={handleClick}
        id="a"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "background-color .3s ease-in-out",
          backgroundColor: isClickedNodeCollapsed ? "#2196F3" : "#BBDEFB",
          padding: "4px 10px",
          borderRadius: "5px",
          width: "100px",
          height: "auto",
          border: "none",
          cursor: "pointer",
          boxShadow:
            "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "fontWeightMedium",
              color: isClickedNodeCollapsed ? "white" : "black",
            }}
          >
            {__(isClickedNodeCollapsed ? "Rozwiń" : "Zwiń")}
          </Typography>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            style={{
              transition: "rotate .3s ease-in-out",
              ...rotate,
            }}
          >
            <path
              d="M9.5 6.22119L5 10.7212L6.0575 11.7787L9.5 8.34369L12.9425 11.7787L14 10.7212L9.5 6.22119Z"
              fill={isClickedNodeCollapsed ? "white" : "black"}
            />
          </svg>
        </Box>
      </Handle>
    </motion.div>
  );
};

export default BottomHandle;
